import React from 'react';
const stats = [{
  value: '+500',
  label: 'Estudiantes confían'
}, {
  value: '12',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'Calificación ⭐'
}];
export function Stats() {
  return <section aria-label="Resultados reales" className="bg-ink-2 border-y border-white/5" data-id="element-149" data-mp="2ixpcctdt751d">
      <div className="mx-auto max-w-5xl px-5 py-10 pt-[0px] pb-[0px]" data-id="element-150" data-mp="2nvh3vmajkp51">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4 pb-[7px] pt-[18px]" data-id="element-151" data-mp="297vxnjide9sw">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-152" data-mp="2dz488ivfs17n">
              <dt className="font-display text-4xl font-black text-white sm:text-5xl" data-id="element-153" data-mp="2e0p72kosa6bb">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-white/60" data-id="element-154" data-mp="205mrf5u4x2lb">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}